import { Suspense } from 'react';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { requireAnyPermission } from '@/features/auth/utils/permissionGuard';
import { PUBLISH_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { BatchMembersPage } from '@/features/publish/pages/BatchMembersPage';
import { batchMembersSearchSchema } from '@/features/publish/types/publish.types';
import { parsePositiveIdParams } from '@/utils/routeParams';

export const Route = createFileRoute('/_auth/publish/batches/$batchId')({
  beforeLoad: () =>
    requireAnyPermission(
      PUBLISH_PERMISSIONS.SALES_VIEW,
      PUBLISH_PERMISSIONS.MIS_VIEW,
      PUBLISH_PERMISSIONS.ACCOUNTS_VIEW,
    ),
  parseParams: (rawParams) => {
    const params = parsePositiveIdParams(rawParams);
    if (params === null) throw notFound();
    return params;
  },
  validateSearch: batchMembersSearchSchema,
  component: function BatchMembersRoute() {
    const { batchId } = Route.useParams();
    const search = Route.useSearch();
    return (
      <ErrorBoundary moduleName="Batch Members">
        <Suspense fallback={<PageLoader />}>
          <BatchMembersPage batchId={batchId} search={search} />
        </Suspense>
      </ErrorBoundary>
    );
  },
});
